module.exports = __webpack_public_path__ + "static/media/Hotel-6@2x.8334b9a1.png";